import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
import { Container, Navbar, Nav, Button } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../Config";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../Pages/Company/Company.css";

const Header_Company = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) setUserData(user);
  }, []);

  const handleLogout = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}Retail_Logout`,
        { userId: userData?.userId },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.responseCode === "0000") {
        logout();
        sessionStorage.removeItem("user");
        navigate("/");
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <Navbar expand="lg" sticky="top" className="co-navbar py-2 mb-3">
      <Container fluid="xl">
        <Navbar.Brand as={NavLink} to="/Company/Company_Dashboard" className="d-flex align-items-center gap-2">
          <img src="../Webdoc_Logo.webp" style={{ width: "84px" }} alt="logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="company-navbar" />
        <Navbar.Collapse id="company-navbar">
          <Nav className="me-auto gap-1 mt-2 mt-lg-0">
            <Nav.Link as={NavLink} to="/Company/Company_Dashboard" end>
              <i className="bi bi-speedometer2 me-1" /> Dashboard
            </Nav.Link>
            <Nav.Link as={NavLink} to="/Company/Company_Report">
              <i className="bi bi-file-earmark-bar-graph me-1" /> Report
            </Nav.Link>
            <Nav.Link as={NavLink} to="/Company/Company_Team">
              <i className="bi bi-people me-1" /> Agents
            </Nav.Link>
            <Nav.Link as={NavLink} to="/Company/Register_Company_Emp">
              <i className="bi bi-person-plus me-1" /> Register
            </Nav.Link>
            <Nav.Link as={NavLink} to="/Company/CompanyPackage">
              <i className="bi bi-box-seam me-1" /> Package
            </Nav.Link>
            <Nav.Link as={NavLink} to="/Company/Agent_AssignPkgs">
              <i className="bi bi-puzzle me-1" /> Agent Packages
            </Nav.Link>
          </Nav>

          <div className="d-flex flex-column flex-lg-row align-items-lg-center gap-2 mt-3 mt-lg-0">
            {userData ? (
              <>
                <span
                  className="badge text-bg-light border text-dark px-3 py-2 text-truncate"
                  style={{ maxWidth: "220px" }}
                >
                  <i className="bi bi-person-circle me-1" />
                  {userData?.name || userData?.email}
                </span>
                <Button variant="outline-danger" size="sm" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right me-1" />
                  Logout
                </Button>
              </>
            ) : (
              <Nav.Link href="/">Login</Nav.Link>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header_Company;
